import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

interface Props {
    pinId: string;
}

const PinterestEmbed = ({ pinId }: Props) => {
	const theme = useTheme();
	const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
	// Create the Pinterest embed HTML
	const pinterestEmbedHtml = isSmUp ? `
		<iframe src="https://assets.pinterest.com/ext/embed.html?id=${pinId}" height="700" width="450" frameborder="0" scrolling="no" ></iframe>
	` : `
		<iframe src="https://assets.pinterest.com/ext/embed.html?id=${pinId}" height="560" width="345" frameborder="0" scrolling="no" ></iframe>
	`;

	return (
		<div style={{ minHeight: '450px', position: 'relative' }}>
			<div
				dangerouslySetInnerHTML={{ __html: pinterestEmbedHtml }}
				style={{ 
					transition: 'opacity 0.3s ease-in-out'
				}}
			/>
		</div>
	);
};

export default PinterestEmbed;
